import React from 'react';
import { Stack } from '@grnhse/seedling/lib/birch/layouts/stack_v2';
import { TertiaryButton } from '@grnhse/seedling/lib/birch/components/buttons';
import {
  Body,
  InlineMarkdown,
  SecondaryBody,
} from '@grnhse/seedling/lib/birch/typography';
import { useFormContext } from '@grnhse/seedling/lib/birch/components/forms/form';
import { withLocalePrefix } from 'shared/utils/translation';
import PopoverButton from 'talent_matching/components/filters/popover_button';
import ApplicationDate from 'talent_matching/components/filters/application_date';
import JobsDepartmentsOfficesFilters from './jobs_departments_offices_filters';
import RelevanceKeywordsFilters from './relevance_keywords_filters';
import { DEFAULT_EXCLUDE_MATCH } from 'talent_matching/types';
import Divider from '@grnhse/seedling/lib/birch/components/divider';

const t = withLocalePrefix('talent_matching.rediscovery.filter_row');

const RelevanceFiltersGroup = () => {
  const { watch, setValue } = useFormContext();
  const [
    appliedOnType,
    jobs,
    departments,
    offices,
    canHave,
    mustHave,
    doesNotHave,
  ] = watch([
    'appliedOnStart',
    'appliedOnEnd',
    'appliedOnType',
    'jobs',
    'departments',
    'offices',
    'can_have',
    'must_have',
    'does_not_have',
  ]);

  const hasJobs = Array.isArray(jobs) && jobs.length > 0;
  const hasDepartments = Array.isArray(departments) && departments.length > 0;
  const hasOffices = Array.isArray(offices) && offices.length > 0;
  const hasApplicationDate = Boolean(appliedOnType);
  const hasKeywords =
    (Array.isArray(canHave) && canHave.length > 0) ||
    (Array.isArray(mustHave) && mustHave.length > 0) ||
    (Array.isArray(doesNotHave) && doesNotHave.length > 0);

  const appliedCount =
    (hasApplicationDate ? 1 : 0) +
    (hasJobs ? 1 : 0) +
    (hasDepartments ? 1 : 0) +
    (hasOffices ? 1 : 0) +
    (hasKeywords ? 1 : 0);

  const clear = () => {
    setValue('appliedOnType', null, { shouldDirty: true });
    setValue('appliedOnStart', null, { shouldDirty: true });
    setValue('appliedOnEnd', null, { shouldDirty: true });
    setValue('jobs', [], { shouldDirty: true });
    setValue('departments', [], { shouldDirty: true });
    setValue('offices', [], { shouldDirty: true });
    setValue('can_have', [], { shouldDirty: true });
    setValue('must_have', [], { shouldDirty: true });
    setValue('does_not_have', [], { shouldDirty: true });
    setValue('does_not_have_match', DEFAULT_EXCLUDE_MATCH, {
      shouldDirty: true,
    });
  };

  const buttonLabel = `${t('relevance.button')}${
    appliedCount ? ` (${appliedCount})` : ''
  }`;

  return (
    <PopoverButton
      buttonLabel={buttonLabel}
      title={t('relevance.title')}
      width="680px"
      contentStyles={{ paddingTop: 0 }}
    >
      <Stack spacing={3}>
        <Body>
          <InlineMarkdown text={t('relevance.description')} />
        </Body>
        <Stack spacing={2}>
          <SecondaryBody medium>
            {t('relevance.application_date_header')}
          </SecondaryBody>
          <ApplicationDate
            helperText={t('relevance.application_date_helper_text')}
          />
        </Stack>

        <Divider />

        <Stack spacing={2}>
          <SecondaryBody medium>{t('relevance.jobs_header')}</SecondaryBody>
          <JobsDepartmentsOfficesFilters />
        </Stack>

        <Divider />

        <Stack spacing={2}>
          <Stack spacing={0.5}>
            <SecondaryBody medium>
              {t('relevance.keywords_header')}
            </SecondaryBody>
            <Body>{t('relevance.keywords_description')}</Body>
          </Stack>
          <RelevanceKeywordsFilters />
        </Stack>

        <Stack sx={{ alignSelf: 'flex-start' }}>
          <TertiaryButton onClick={clear} size="md">
            {t('clear')}
          </TertiaryButton>
        </Stack>
      </Stack>
    </PopoverButton>
  );
};

export default RelevanceFiltersGroup;
